import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@clerk/react";
import { Check, Crown, Loader2 } from "lucide-react";
import { API, useApi, errMsg } from "@/lib/api";
import { useMe } from "@/context/MeContext";

const PERKS = ["Estadísticas detalladas de reproducciones", "Tus postulaciones a la radio se revisan primero", "Destacar cuesta 2 créditos en vez de 3", "Insignia PRO en tu Press Kit"];

export function ProPlans() {
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState("");
  const { isLoaded, isSignedIn } = useAuth();
  const { me } = useMe();
  const api = useApi();
  const navigate = useNavigate();
  useEffect(() => { axios.get(`${API}/pro/plans`).then((r) => setPlans(r.data)).catch(() => {}); }, []);

  const subscribe = async (id) => {
    if (!isLoaded) return;
    if (!isSignedIn) { navigate("/sign-up"); return; }
    setBusy(id);
    try {
      const { checkout_url } = await api("post", "/pro/checkout", { plan_id: id, origin_url: window.location.origin });
      window.location.href = checkout_url;
    } catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };

  return (
    <section data-testid="pro-plans" className="mt-24">
      <p className="flex items-center gap-2 font-mono text-xs tracking-widest text-amber-500/90"><Crown className="h-4 w-4" />PLAN PRO PARA ARTISTAS</p>
      <h2 className="mt-3 max-w-2xl font-heading text-3xl font-bold text-white sm:text-4xl">Créditos todos los meses y más ventajas.</h2>
      <p className="mt-3 max-w-xl text-slate-400">Suscripción mensual: los créditos se suman a tu saldo con cada renovación. Cancela cuando quieras.</p>
      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {plans.map((p) => (
          <div key={p.id} data-testid={`pro-plan-${p.id}`} className="flex flex-col rounded-2xl border border-amber-500/30 bg-gradient-to-b from-[#1b1610] to-[#12121A] p-8">
            <p className="font-mono text-xs tracking-widest text-amber-400">{p.name.toUpperCase()}</p>
            <p className="mt-4 font-heading text-5xl font-extrabold text-white">USD {p.price_usd}<span className="ml-2 text-lg font-bold text-slate-400">/ mes</span></p>
            <p className="mt-2 text-slate-300">{p.credits} créditos cada mes</p>
            <ul className="mt-6 space-y-2 text-sm text-slate-400">
              {PERKS.map((t) => <li key={t} className="flex items-center gap-2"><Check className="h-4 w-4 text-emerald-400" />{t}</li>)}
            </ul>
            {me?.is_pro ? (
              <p className="mt-8 rounded-full border border-white/10 py-3 text-center text-sm text-slate-400">{me.pro_plan === p.id ? "Tu plan actual" : "Ya tienes un plan Pro activo"}</p>
            ) : (
              <button data-testid={`subscribe-${p.id}-btn`} disabled={!!busy || me?.role === "curator"} onClick={() => subscribe(p.id)} className="mt-8 flex items-center justify-center gap-2 rounded-full bg-amber-400 py-3 font-semibold text-black transition-colors hover:bg-amber-300 disabled:opacity-50">
                {busy === p.id && <Loader2 className="h-4 w-4 animate-spin" />} Suscribirme
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
